import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { DateRangeFilterLabel } from "./DateRangeFilterLabel";

interface Props {
    filters: FiltersTypes;
}

export const TaskCreatedOnFilterLabel: React.FC<Props> = ({ filters }) => {
    const { taskCreatedAtStart, taskCreatedAtEnd } = filters;

    return (
        <DateRangeFilterLabel
            start={taskCreatedAtStart}
            end={taskCreatedAtEnd}
        />
    );
};
